import { useLanguage } from "@/context/LanguageContext";
import { copy } from "@/content";

export const Footer = () => {
  const { lang } = useLanguage();
  const t = copy[lang].footer;
  const nav = copy[lang].nav;

  return (
    <footer className="bg-ink" data-testid="site-footer">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-10 px-6 py-16 md:flex-row md:items-end md:justify-between md:px-12">
        <div>
          <p className="flex items-baseline gap-1">
            <span className="font-tty text-3xl font-bold text-white">Libertec</span>
            <span className="animate-caret font-tty text-3xl font-bold text-acid">_</span>
          </p>
          <p className="mt-4 font-tty text-sm text-neutral-400">{t.tagline}</p>
        </div>
        <nav className="flex flex-wrap gap-6 font-tty text-xs uppercase tracking-[0.2em] text-neutral-400">
          <a href="#manifesto" className="transition-colors hover:text-acid">{nav.manifesto}</a>
          <a href="#servicos" className="transition-colors hover:text-acid">{nav.services}</a>
          <a href="#contacto" className="transition-colors hover:text-acid">{nav.contact}</a>
          <a href="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-acid">{t.admin}</a>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-[1600px] px-6 py-6 font-tty text-[11px] uppercase tracking-[0.2em] text-neutral-600 md:px-12" data-testid="footer-rights">
          {t.rights}
        </p>
      </div>
    </footer>
  );
};
